/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack,
  Box,
  VStack,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { MyProfileContext } from '../context';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAiSuggestedIntro,
  clearSuggestion,
  setInfoPermissions,
} from 'v4/store/actions/user-profile.actions';
import {
  CallLockIcon,
  EarthGlobeIcon,
  LockIcon,
  OnlyMeLockIcon,
  Security,
  TeamIcon,
} from '@mybridge/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const CreateAudiencePermissionModal = forwardRef(
  ({ setPermissionValue, ...props }, ref) => {
    const dispatch = useDispatch();
    const { t } = useTranslator();
    const {
      userProfileInfo,
      currentPermissionValue,
      setCurrentPermissionValue,
      updateProfilePermissionsAsync,
      
    } = useContext(MyProfileContext);

    const [radioValue, setRadioValue] = useState(
      props.media
        ? props.audienceValue || 1
        : currentPermissionValue
        ? Number(currentPermissionValue) || 1
        : 1
    );

    const onSubmit = () => {
      let payload = {};

      payload = {
        attribute: props?.media,
        audience: Number(radioValue), // 1 public | 2 mynetwork | 3 only me
      };

      updateProfilePermissionsAsync?.(payload);
      setPermissionValue(Number(radioValue));
      props.onClose();
    };

    useEffect(() => {
      setCurrentPermissionValue?.(Number(radioValue));
    }, [currentPermissionValue]);

    return (
      <>
        <Modal size="xl" {...(props ?? {})}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader borderBottom="1px solid #ddd" textAlign="center">
              {t('profileDetails.selectAudience') || "Select Audience"}
              <ModalCloseButton />
            </ModalHeader>
            <ModalBody>
              <RadioGroup onChange={setRadioValue} value={Number(radioValue)}>
                <VStack gap={3} align="stretch">
                  <HStack justifyContent="space-between">
                    <HStack>
                      <Stack
                        w="50px"
                        h="50px"
                        borderRadius="50%"
                        bg="#D9D9D9"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <EarthGlobeIcon />
                      </Stack>
                      <VStack alignItems="flex-start" gap="0">
                        <Text
                          fontSize="18px"
                          fontWeight="600"
                          color="brandPrimary.500"
                        >
                          {t('profileDetails.public') || 'Public'}
                        </Text>
                        <Text>{t('profileDetails.anyoneOnOrOffMyBridge') || "Anyone on or off myBridge"}</Text>
                      </VStack>
                    </HStack>
                    <Radio value={1} />
                  </HStack>
                  <HStack justifyContent="space-between">
                    <HStack>
                      <Stack
                        w="50px"
                        h="50px"
                        borderRadius="50%"
                        bg="#D9D9D9"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <TeamIcon color={'#5B5B5B'} />
                      </Stack>
                      <VStack alignItems="flex-start" gap="0">
                        <Text
                          fontSize="18px"
                          fontWeight="600"
                          color="brandPrimary.500"
                        >
                          {t('profileDetails.myNetwork') || 'myNetwork'}
                        </Text>
                        <Text>{t('profileDetails.yourNetworksOnMyBridge') || "Your networks on myBridge"}</Text>
                      </VStack>
                    </HStack>
                    <Radio value={2} />
                  </HStack>
                  <HStack justifyContent="space-between">
                    <HStack>
                      <Stack
                        w="50px"
                        h="50px"
                        borderRadius="50%"
                        bg="#D9D9D9"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <OnlyMeLockIcon />
                      </Stack>
                      <VStack alignItems="flex-start" gap="0">
                        <Text
                          fontSize="18px"
                          fontWeight="600"
                          color="brandPrimary.500"
                        >
                          {t('profileDetails.onlyMe') || 'Only me'}
                        </Text>
                        {/* <Text>Anyone on or off myBridge</Text> */}
                      </VStack>
                    </HStack>
                    <Radio value={3} />
                  </HStack>
                </VStack>
              </RadioGroup>
            </ModalBody>
            <ModalFooter borderTop="1px solid #ddd">
              <HStack>
                <Button borderRadius="50px"
                  onClick={() => {
                    props?.onClose();  
                  }}
                >
                  {t('buttons.cancel') || 'Cancel'}
                </Button>
                <Button borderRadius="50px" variant="primary" onClick={() => onSubmit()}>
                  {t('buttons.done') || 'Done'}
                </Button>
              </HStack>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  }
);
